import React from "react";

import Dropzone from "react-dropzone";

import Add from "@material-ui/icons/Add";

import { Box, Hint, Title } from "./styles";

interface UploadDropzoneProps {
    onDrop: (files: File[]) => void;
    width?: number;
    height?: number;
    hint?: React.ReactNode;
    className?: string;
    /** Фильтр системного диалога. Размер и длительность проверяет вызывающая сторона. */
    accept?: string;
}

export const UploadDropzone = ({
    onDrop,
    width,
    height,
    hint,
    className,
    accept,
}: UploadDropzoneProps) => (
    <Dropzone onDrop={onDrop} accept={accept}>
        {({ getRootProps, getInputProps }) => (
            <Box {...getRootProps()} className={className} $width={width} $height={height}>
                <input {...getInputProps()} />
                <Add />
                <Title>Загрузить</Title>
                {hint && <Hint>{hint}</Hint>}
            </Box>
        )}
    </Dropzone>
);
